<template>
  <div class="did-container">
    <div class="d-flex align-items-center mb-4">
      <div class="search-box d-flex align-items-center mr-sm-3">
        <search-input class="search-input" placeholder="Search DID" v-model="SearchDid" />
      </div>

      <div class="w-100" v-if="showButton">
        <filters-actions
                class="nav-container"
                @add="$router.push({name: 'company-admin-dids-buy-did'})"
                @download="downloadXls('table', 'Lorem Table')"
                :addButtton="{ text: 'Buy Did', class: 'mr-2' }"
                :downloadButtton="{ text: 'Download' }"
        />
      </div>
    </div>



    <loader :loading="loading" v-if="loading" />
    <div v-else-if="!dids.length" class="no-data-found">No Data Found</div>

    <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden" v-else>
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header">
            <th class="number">
              Number
              <span v-on:click="sorting('up','did')" class="sorting">&#8593;</span>
              <span v-on:click="sorting('down','did')" class="sorting">&#8595;</span>
            </th>
            <th>
              Created On
              <span v-on:click="sorting('up','created_on')" class="sorting">&#8593;</span>
              <span v-on:click="sorting('down','created_on')" class="sorting">&#8595;</span>
            </th>
            <th>Country</th>
            <th>MRC</th>
            <th>NRC</th>
            <th>State</th>
            <th>Lata</th>
            <th>Type</th>
            <th class="action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="line" v-if="dids.length > 0" v-for="(did, k) in dids" :key="k">
            <th class="number">
              <img
                v-if="did.active"
                class="number-icon"
                @click="isActive(did)"
                src="@/assets/Icon/Check/Active.svg"
                alt
              />
              <img
                v-if="!did.active"
                class="number-icon"
                @click="isActive(did)"
                src="@/assets/Icon/Check/Default.svg"
                alt
              />
              {{did.number}}
            </th>
            <th>{{did.created_on}}</th>
            <th>{{did.countryName}}</th>
            <th>{{did.mrc}}</th>
            <th>{{did.nrc}}</th>
            <th class>{{did.state}}</th>
            <th>{{did.lata}}</th>
            <th>Local</th>

            <th class="icon action">
              <secondary-button class="callflow" @click.native="() => disconnect(did)">Disconnect</secondary-button>
              <svg
                @click="$router.push({name: 'company-admin-dids-edit-did', params: {id: did.number}})"
                class="svg-grey"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                  id="path-1"
                />
              </svg>
              <svg
                @click="deleteDid(did.number)"
                class="svg-grey delete"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                  id="path-1"
                />
              </svg>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="per-page">
      <span class="filter_by custom-row white_space">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper" v-if="dids.length">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :perPage="per_page"
        :total="TotalPages"
        :qnt="dids.length"
      />
    </div>
    <table class="Invoice_table" ref="table" style="display:none;">
      <thead>
        <tr class="Invoice_table_header">
          <th>Number</th>
          <th>Created On</th>
          <th>Country</th>
          <th>MRC</th>
          <th>NRC</th>
          <th>State</th>
          <th>Lata</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <tr class="line" v-if="dids.length > 0" v-for="(did, k) in dids" :key="k">
          <th>{{did.number}}</th>
          <th>{{did.created_on}}</th>
          <th>{{did.countryName}}</th>
          <th>{{did.mrc}}</th>
          <th>{{did.nrc}}</th>
          <th class>{{did.state}}</th>
          <th>{{did.lata}}</th>
          <th>Local</th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    FiltersActions: () => import("@/components/FiltersAndActions.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    types: ["Landline", "Virtual", "Toll Free", "Mobile"],
    showDropDown: false,
    dids: [],
    Page: 0,
    SearchDid: "",
    TotalPages: null,
    company_logo_path: null,
    type: null,
    active: null,
    selectedDids: [],
    loading: false,
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
    showButton: false,
    timeout: null,
    uri: "data:application/vnd.ms-excel;base64,",
    template:
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
    base64: function (s) {
      return window.btoa(unescape(encodeURIComponent(s)));
    },
    format: function (s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p];
      });
    },
  }),
  watch: {
    SearchDid: function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!this.per_page) {
          this.per_page = 10;
        }
        this.Page = 0;
        this.GetList();
      }, 800);
    },
    type: function () {
      this.Page = 0;
      this.GetList();
    },
  },
  created() {
    this.GetList();
    this.$store
      .dispatch("GetCompany", this.$store.getters.getUser.company_uuid)
      .then((res) => {
        this.company_logo_path = res.contact.logo_file_uuid;
      });
  },
  methods: {
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.order_dir = order_dir;
      this.order_by = sortBy;

      this.GetList(order_dir, sortBy);
    },
    downloadXls(table, name) {
      if (!table.nodeType) table = this.$refs.table;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };

      const link = document.createElement("a");
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.setAttribute("download", "dids.xls");
      link.click();
    },
    isActive(did) {
      this.selectedDids.push(did.number);
      this.active = !this.active;
      this.dids.map((item) => {
        if (item == did) {
          did.active = !did.active;
        }
      });
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    changePerPage(e) {
      this.Page = 0;
      this.per_page = e;
      this.GetList();
    },
    GetList(order_dir = "", sortBy = "") {
      this.loading = true;
      this.showButton = true;
      this.$store
        .dispatch("GetAllDidsLocal", {
          page: this.Page,
          perPage: this.per_page ? this.per_page : 10,
          is_toll_free: false,
          sortBy: sortBy,
          order_dir: order_dir,
          did: this.SearchDid || "",
        })
        .then((res) => {
          console.log(res.items);
          this.dids = res.items.map(this.transformDids);
          this.TotalPages = res.total / res.per_page;
        })
        .catch((err) => this.$error(err))
        .finally(() => (this.loading = false));
    },
    disconnect(did) {
      this.loading = true;
      let data = { items: [{ number: did.number }] };
      this.$store
        .dispatch("disconnectPrefixList", data)
        .then((res) => {
          this.$success("Success");
          this.GetList();
          this.loading = false;
        })
        .catch((err) => {
          this.$error(err);
          this.loading = false;
        });
    },
    deleteDid(did) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this did!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("AssignDid", {
              did: did,
              companyId: { company_uuid: null },
            })
            .then(() => {
              this.$swal("Deleted!", "Did has been deleted.", "success");
              this.GetList();
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      });
    },
    transformDids(i, k) {
      return {
        number: i.did,
        // created_on: i.created_on,
        created_on: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        countryName: "USA", // this.GetCountryName(i.country_uuid),
        state: i.state,
        mrc: i.mrc,
        nrc: i.nrc,
        lata: i.lata,
        type: i.type,
        didType: i.did_type,
        active: false,
      };
    },
    GetCountryName(id) {
      this.$store.dispatch("UserGetCountry", id).then((res) => {
        return res.nice_name;
      });
    },
  },
};
</script>

<style>
.content .add-navigation .right-wrapper {
  display: none !important;
}
</style>
<style lang="scss" scoped>
.did-container {
  .nav-container {
    margin-top: 0;
    margin-right: 20px;
  }
  .search-box {

    .search-input {
      width: 245px;
      background: #fff;
    }
  }
}
.per-page {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.perPage {
  width: 120px !important;
  display: inline-block;
}
.add-navigation.nav-container {
  // display: inline-block !important;
  display: block;
  float: right;
  margin-right: 0;
}
.custom-row {
  margin-right: 10px;
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;
  }
  th.number {
    width: 220px;
    padding-right: 20px;
  }
  th.action {
    width: 200px;
    padding-left: 0;
    padding-right: 0;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px 10px 0 20px;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 20px;
}
tbody {
  th.icon {
    padding: 7px 20px 7px 0;
    float: right;
    min-width: 80px;
  }
  .img-container {
    padding: 7px 0;
  }
}
th .secondary-button {
  height: 40px;
  width: 90px;
  //margin-bottom: 0;
}
th .svg-grey {
  cursor: pointer;
  fill: #55616e;
}
th .callflow {
  font-size: 12px;
  width: 110px;
  height: 20px;
  padding-top: 0px;
  line-height: 20px;
}
th .number-icon {
  height: 16px;
  width: 16px;
  margin-right: 10px;
  float: left;
}
.no-data-found {
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #e2e5ea;
  background-color: #fff;
}
.sorting {
  font-size: 18px;
  cursor: pointer;
}
@media (max-width: 1718px) {
  table.Invoice_table {
    width: 1608px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

